<template>
  <div class="homePage">
    <zdy-nav leftTitle="帮助与反馈" @back="back"></zdy-nav>
    <Spin v-if="showLoading" fix>
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>加载中，请稍后</div>
    </Spin>
    <div class="scroll-list-wrap chat-window" :style="isIphone || isHarmony?'':'height: calc(100vh - 135px);'">
      <cube-scroll
        :data="chatList"
        ref="cubeScroll"
        :scrollEvents="['scroll']"
        @scroll="scrollEnd"
      >
        <!-- 问候语 -->
        <chat-content :chatItme="greetObj" :robotConfig="robotConfig"></chat-content>
        <!-- 猜您想问 -->
        <issue-bar
          title="猜您想问"
          :list="issueList"
          @allIssue="allIssue"
          @clickList="clickList"
          :robotConfig="robotConfig"
        ></issue-bar>
        <!-- 聊天内容 -->
        <chat-content
          v-for="(item, index) in chatList"
          :key="index"
          :chatItme="item"
          :robotConfig="robotConfig"
          @toDetails="serviceDetails"
          @clickList="clickList"
        ></chat-content>
      </cube-scroll>
    </div>
    <!-- 自助工具 -->
    <self-help-tools :list="list" class="self-help-tools"></self-help-tools>
    <input-field @sendMsg="sendMsg" ref="input-field" @inputFocus="inputFocus"></input-field>
    <!-- 办事指南 -->
    <Drawer class-name="serviceShell-drawer" placement="bottom" :closable="false" v-model="guideModal" @on-visible-change="changeGuide">
      <div slot="header">
        <div class="sd-headInfo">
          <div class="headInfo-title">办事指南</div>
          <div class="headInfo-icon" @click="closeDrawer">
            <Icon type="md-close" />
          </div>
        </div>
      </div>
      <div class="sd-ct">
        <div class="ct-head">
          <div class="head-list">
            <!-- <div class="list-item" :id="`nav${item.templateId}`" @click="toChooseItem(item)" :class="nowItemId === item.templateId ? 'list-item-c' : ''"
              v-for="(item, index) in columnInfo" :key="index + item.templateId">{{ item.name }}</div> -->
            <div class="head-list-cs-list">
              <cube-scroll
                ref="scroll"
                nestMode="none"
                :options="{}"
                direction="horizontal">
                <div class="cube-scroll-nav-bar-items" ref="items">
                  <div
                    class="cube-scroll-nav-bar-item"
                    v-for="(item, index) in columnInfo"
                    :key="index"
                    :class="nowItemId === item.templateId ? 'cube-scroll-nav-bar-item_active' : ''"
                    @click.stop="toChooseItem(item, 1)">
                    <!-- <div>{{ item.name }}</div> -->
                    <div>{{ item.name.length > 6 ? `${item.name.slice(0, 6)}...` : item.name }}</div>
                  </div>
                </div>
              </cube-scroll>
            </div>
            <!-- <div class="list-bk">
              <img src="@/assets/sha.png" alt="">
            </div> -->
          </div>
          <div class="head-icon" @click.stop="showAllFl">
            <div class="list-bk">
              <img src="@/assets/sha.png" alt="">
            </div>
            <Icon type="ios-menu" />
          </div>
        </div>
        <div class="ct-head-showAll" v-if="showFl">
          <div class="showAll-info">
            <div class="showAll-title">
              <div class="title-info">点击进入对应分类</div>
              <div class="title-icon" @click="closeFl">
                <Icon type="md-close" />
              </div>
            </div>
            <div class="showAll-line">
              <div class="line-item" @click="toChooseItem(item, 2)" :class="nowItemId === item.templateId ? 'line-item-c' : ''" v-for="(item, index) in columnInfo" :key="index + item.templateId">{{ item.name }}</div>
            </div>
          </div>
          <div class="showAll-back" @click.stop="closeFl"></div>
        </div>
        <div class="ct-info" id="ctInfoList">
          <div class="info-list" id="znjbxx">
            <div class="info-item" v-if="keyInfo.length">
              <div class="item-line" v-for="(item, index) in keyInfo" :key="index">
                <div class="line-left">{{ item.viewName }}：</div>
                <div class="line-right">{{ item.value || '无' }}</div>
              </div>
            </div>
            <div class="info-item">
              <div class="item-title">基本信息</div>
              <div class="item-line" v-for="(item, index) in baseInfo" :key="index">
                <div class="line-left">{{ item.viewName }}：</div>
                <div class="line-right">{{ item.value || '无' }}</div>
              </div>
            </div>
          </div>
          <template v-for="(item, index) in columnInfo">
            <div class="info-list" :id="`zn${item.templateId}`" v-if="item.templateId !== 'jbxx'" :key="index">
              <div class="info-item">
                <div class="item-title">{{ item.name }}</div>
                <div :ref="`editor-content-view${item.templateId}`" class="generalDetailsTow_centent editor-content-view" v-html="(!item.value || item.value === '<p><br></p>') ? '无' : item.value"></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { setStore, getStore } from '@/utils/store'
import { cloneDeep } from 'lodash'
export default {
  data() {
    return {
      list: [
        {
          // img: 'img/fankui.png',
          title: '常见问题',
          click: () => {
            this.recommendLIst('normal')
          }
        },
        {
          // img: 'img/fankui.png',
          title: '异常反馈',
          click: () => {
          this.$router.push({
            name: 'feedbackPageIndex'
          })
          setStore({name: 'fromType', content: {type: '1'}, type: 'session'})
          }
        },
        {
          // img: 'img/jianyi.png',
          title: '功能建议',
          click: () => {
            this.$router.push({
              name: 'feedbackPageIndex'
            })
            setStore({ name: 'fromType', content: { type: '2' }, type: 'session' })
          },
        },
        {
          // img: 'img/update.png',
          title: '检查更新',
          click: () => {
            this.$cjc.apiCheckAppUpdate();
          },
        },
      ],
      issueList: [], // 问题列表
      chatList: [], // 聊天列表
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      greetObj: {}, // 问候语
      robotConfig: {}, // 机器人配置
      showBtn: true, // 是否显示常见问题
      scrollRecord: null,
      showLoading: false,
      guideModal: false,
      nowItemId: 'jbxx',
      keyInfo: [], // 关键信息
      baseInfo: [], // 基本信息
      showFl: false,
      columnInfo: [], // 栏目信息
      canScroll: true 
    };
  },
  async created() {
    document.title = '帮助与反馈'
    this.showLoading = true
    await this.getRobotConfig()
    await this.getAiquestionGreet()
    await this.getQuestionList();
    await this.recommendLIst('created')
    if (getStore({name: 'chatList'})) {
      this.chatList = getStore({ name: 'chatList' })
      this.$nextTick(() => {
        const positionObj = getStore({name: 'positionObj'})
        console.log('positionObj', positionObj)
        if (positionObj && positionObj.y !== 0) {
          this.$refs.cubeScroll.scrollTo(0, positionObj.y + 20, 0)
        }
      })
    }
    this.showLoading = false
    console.log(this.$cjc)
  },
  computed:{
    isIphone(){
      console.log(navigator.userAgent,12312313);
      return /iphone/gi.test(navigator.userAgent)&& (screen.height >= 812)
    },
    isHarmony(){
      console.log(navigator.userAgent,12312313);
      return /OpenHarmony/gi.test(navigator.userAgent)
    },
  },
  methods: {
    back() {
      this.$cjc.closeWebView();
    },
    // 获取机器人配置
    async getRobotConfig () {
      const res = await this.$store.dispatch('getRobotConfig')
      if (res.data.status === 1000) {
        this.robotConfig = res.data.result
        setStore({name: 'robotConfig', content: this.robotConfig, type: 'session'})
        if (!this.robotConfig.useType) {
          this.$router.replace({name: 'allIssue'})
        }
      } else {
        this.showMessage(res.data.msg)
      }
    },
    // 获取机器人问候语
    async getAiquestionGreet () {
      const res = await this.$store.dispatch('getAiquestionGreet')
      if (res.data.status === 1000) {
        this.greetObj = {msg: res.data.result, type: 4}
      } else {
        this.showMessage(res.data.msg)
      }
    },
    // 获取猜你想问列表
    async getQuestionList() {
      const res = await this.$store.dispatch('getAiquestionWantAnswer')
      if (res.data.status === 1000) {
        this.issueList = res.data.result;
      } else {
        this.showMessage(res.data.msg)
      }
      // this.$store.dispatch('questionList', {
      //   current: this.pageIndex,
      //   size: this.pageSize,
      // }).then((res) => {
      //   const { result } = res.data;
      //   if (res.data.status === 1000) {
      //     this.issueList = result.records;
      //     this.total = result.total;
      //   } else {
      //     this.showMessage(res.data.msg)
      //   }
      // })
    },
    // 记录问题
    async recordPort (item, type) {
      const { userInfo } = this.$store.state;
      console.log('this.userInfo', userInfo)
      const params = {
        questionId: item.questionId,
        keyId: userInfo.USER_ID,
        // keyId: 1679534294618112,
        useType: '手机',
        useDevice: userInfo.phoneType == 2 ? '安卓' : 'iOS',
        // useDevice: '安卓',
        deviceType: userInfo.model,
        // deviceType: '2211133c',
        question: type === '1' ? item.questionName : item.question
      }
      const res = await this.$store.dispatch('recordQuestion', params)
      if (res.data.status === 1000) {
        return res.data.result
      } else{
        this.showMessage(res.data.msg)
      }
    },
    // 点击猜你想问的问题
    async clickList (item) {
      const questionId = await this.recordPort(item, '1')
      let itemObj = {
        type: 1,
        msg: item.questionName,
      }
      this.chatList = this.chatList.concat(itemObj)
      const resultObj = {
        type: item.answerType === 1 ? 4 : 6,
        msg: item.answer,
        activeNum: 0,
        quizId: questionId
      }
      setTimeout(()=>{
        const cubeScroll = this.$refs.cubeScroll.scroll; 
        this.chatList = this.chatList.concat(resultObj)
        if (cubeScroll.scrollerHeight > cubeScroll.wrapperHeight) {
          this.$refs.cubeScroll.scrollTo(
            0,
            -cubeScroll.scrollerHeight,
            500,
          )
        }
      }, 500)
    },
    // 获取常见问题列表
    async recommendLIst (type) {
      const res = await this.$store.dispatch('recommendLIst', {})
      if (res.data.status === 1000) {
        if (res.data.result && !res.data.result.length) {
          if (type === 'normal') {
            this.sendMsg('常见问题', 'msg')
          }
          this.showBtn = false
          if (this.list[0].title === '常见问题') {
            this.list.splice(0, 1)
          }
        } else {
          if (type !== 'created') {
            let itemObj = {
              type: 1,
              msg: '常见问题',
            }
            this.chatList = this.chatList.concat(itemObj)
            const resultObj = {
              type: 5,
              msg: res.data.result,
            }
            setTimeout(() => {
              this.chatList = this.chatList.concat(resultObj)
              const cubeScroll = this.$refs.cubeScroll.scroll;
              if (cubeScroll.scrollerHeight > cubeScroll.wrapperHeight) {
                this.$refs.cubeScroll.scrollTo(
                  0,
                  -cubeScroll.scrollerHeight,
                  500,
                )
              }
            }, 500)
          }
        }
      } else {
        this.showMessage(res.data.msg)
      }
    },
    // 发送消息
    sendMsg(msg, type) {
      if (!msg) return;
      if (msg === '常见问题') {
        if (type === 'msg') {
          this.sendMsgPort('常见问题')
        } else {
          this.recommendLIst('normal')
        }
      } else {
        this.sendMsgPort(msg)
      }
    },
    sendMsgPort(msg) {
      const { userInfo } = this.$store.state;
      const sendObj = {
        type: 1, // 用户发言
        msg,
      };
      this.chatList = this.chatList.concat(sendObj);
      const cubeScroll = this.$refs.cubeScroll.scroll;
      console.log('(cubeScroll.scrollerHeight', cubeScroll.scrollerHeight)
      console.log('(cubeScroll.wrapperHeight', cubeScroll.wrapperHeight)
      if (cubeScroll.scrollerHeight > cubeScroll.wrapperHeight) {
        this.$refs.cubeScroll.scrollTo(
          0,
          -cubeScroll.scrollerHeight,
          500,
        )
      }
      this.$store.dispatch('robotSearchLucene', {
        keyId: userInfo.USER_ID,
        // keyId: 1679534294618112,
        useType: '手机',
        useDevice: userInfo.phoneType == 2 ? '安卓' : 'iOS',
        // useDevice: '安卓',
        deviceType: userInfo.model,
        // deviceType: '2211133c',
        question: msg,
        userEnvironment: 1 // 1 App
      }).then((res) => {
        if (res.data.status === 1000) {
          const { result } = res.data;
          let resultObj = {};
          if (result.resultList.length > 0) {
            resultObj = {
              type: 2, // 问答服务
              resultList: result.resultList,
            }
          } else {
            resultObj = {
              type: 3, // 无法理解提问
              noResultMsg: result.noResultMsg,
            }
          }
          this.chatList = this.chatList.concat(resultObj);
          const cubeScroll = this.$refs.cubeScroll.scroll;
          if (cubeScroll.scrollerHeight > cubeScroll.wrapperHeight) {
            this.$refs.cubeScroll.scrollTo(
              0,
              -cubeScroll.scrollerHeight,
              500,
            )
          }
        } else {
          this.showMessage(res.data.msg)
        }
      })
    },
    inputFocus() {
    },
    // 全部问题
    allIssue() {
      this.$router.push({ name: 'allIssue' });
    },
    // 点击想了解的问题
    async serviceDetails(item) {
      // type 1 问答 2 服务 3 办事指南
      // valueType 1 文本 2 链接
      console.log('serviceDetails', item)
      if (item.type === 2) {
        this.enterService(item);
      }else if (item.type === 3) {
          this.showLoading = true
          await this.clientGuideInfo(item)
          this.showLoading = false
      } else {
        const questionId = await this.recordPort(item, '2')
        let itemObj = {
          type: 1,
          msg: item.question,
        }
        this.chatList = this.chatList.concat(itemObj)
        const resultObj = {
          type: item.valueType === 1 ? 4 : 6,
          msg: item.content,
          activeNum: 0,
          quizId: questionId
        }
        setTimeout(() => {
          const cubeScroll = this.$refs.cubeScroll.scroll;
          this.chatList = this.chatList.concat(resultObj)
          if (cubeScroll.scrollerHeight > cubeScroll.wrapperHeight) {
            this.$refs.cubeScroll.scrollTo(
              0,
              -cubeScroll.scrollerHeight,
              500,
            )
          }
        }, 500)
      }
    },
    // 进入服务
    async enterService(item) {
      const res = await this.$store.dispatch('findServiceInfo', {id: item.id })
      if (res.data.status === 1000) {
        console.log()
        this.openWindow(res.data.result.shortUrl ? res.data.result.shortUrl : res.data.result.serviceUrl, res.data.result.serviceName, false)
      } else {
        this.showMessage(res.data.msg)
      }
    },
    // 换一换
    changeData() {
      const pages = Math.ceil(this.total / 6);
      if (this.pageIndex < pages) {
        this.pageIndex += 1;
      } else {
        this.pageIndex = 1;
      }
      this.getQuestionList();
    },
    openWindow(serviceUrl, title, hiddenNavigation){
      if (this.environment.isFengChao) {
        this.$cjc.openNewWebView({
          'url': serviceUrl,
          'title': title == undefined ? '详情页' : title,
          'hiddenNavigation': hiddenNavigation
        })
      } else {
        window.open(serviceUrl);
      }
    },
    // 显示提示信息弹窗
    showMessage (msg) {
      const toast = this.$createToast({
        txt: msg,
        time: 2000,
        type: 'error',
      })
      toast.show()
    },
    // 滚动结束位置
    scrollEnd(obj) {
      if (this.scrollRecord) {
        clearTimeout(this.scrollRecord)
        this.scrollRecord = null
      }
      this.scrollRecord = setTimeout(() => {
        setStore({name: 'positionObj', content: obj, type: 'session'})
      }, 30)
    },
    // 获取办事指南
    async clientGuideInfo(item) {
      const res = await this.$store.dispatch('clientGuideInfo', {
        isLogin: true, // 登录的情况下固定传true
        serviceId: item.id // 服务id
      })
      console.log(res, '办事指南')
      if (res.data.status === 1000) {
        const resInfo = cloneDeep(res.data.result)
        console.log(resInfo, '123')
        if (resInfo.guideBaseList.length) {
          for (let i = 0; i < resInfo.guideBaseList.length; i++) {
            const info = resInfo.guideBaseList[i]
            if (info.isKeyInfo) {
              this.keyInfo.push(info)
            } else {
              this.baseInfo.push(info)
            }
          }
        }
        if (resInfo.guideColumnList.length) {
          this.columnInfo = resInfo.guideColumnList
          this.columnInfo.unshift({
            name: '基本信息',
            templateId: 'jbxx'
          })
        }
        const Vm = this
        document.querySelector('#ctInfoList').removeEventListener('scroll', Vm.onScroll)
        Vm.guideModal = true
        Vm.$nextTick(() => {
          document.querySelector('#ctInfoList').addEventListener('scroll', Vm.onScroll, false)
          setTimeout(() => {
            Vm.getImgClick()
          }, 200)
        })
      } else {
        this.$Message.error(res.data.msg)
      }
    },
    // 弹窗变化
    changeGuide(res) {
      console.log(res, '123')
      if (!res) {
        document.querySelector('#ctInfoList').removeEventListener('scroll', this.onScroll)
        this.canScroll = true
        this.showFl = false
        this.nowItemId = 'jbxx'
        this.keyInfo = []
        this.baseInfo = []
        this.columnInfo = []
      }
    },
    // 选中nav
    toChooseItem(item, type) {
      console.log(item)
      const Vm = this
      document.querySelector('#ctInfoList').removeEventListener('scroll', Vm.onScroll, false)
      Vm.nowItemId = item.templateId
      Vm.adjust()
      Vm.$nextTick(() => {
        if (type === 2) {
          Vm.showFl = false
        }
        const toLabel = document.getElementById(`zn${Vm.nowItemId}`)
        if (toLabel) {
          toLabel.scrollIntoView(true)
          setTimeout(() => {
            this.canScroll = false
            document.querySelector('#ctInfoList').addEventListener('scroll', Vm.onScroll, false)
          }, 0)
        } else {
          this.canScroll = false
          document.querySelector('#ctInfoList').addEventListener('scroll', Vm.onScroll, false)
        }
      })
    },
    // 跳转
    adjust() {
      // waiting ui
      const Vm = this
      Vm.$nextTick(() => {
        const isHorizontal = 'horizontal'
        const targetProp = isHorizontal ? 'clientWidth' : 'clientHeight'
        const active = Vm.nowItemId
        const viewportSize = Vm.$refs.scroll.$el[targetProp]
        const itemsEle = Vm.$refs.items
        const scrollerSize = itemsEle[targetProp]
        const minTranslate = Math.min(0, viewportSize - scrollerSize)
        const middleTranslate = viewportSize / 2
        const items = itemsEle.children
        let size = 0
        Vm.columnInfo.every((item, index) => {
          if (item.templateId === active) {
            size += (items[index][targetProp] / 2)
            return false
          }
          size += items[index][targetProp]
          return true
        })
        let translate = middleTranslate - size
        translate = Math.max(minTranslate, Math.min(0, translate))
        console.log(333333333344444)
        Vm.$refs.scroll.scrollTo(isHorizontal ? translate : 0, isHorizontal ? 0 : translate, 300)
      })
    },
    // 栏目滚动到中间
    toLabelCenter() {
      const flLabel = document.querySelector('.list-item-c')
      const ul = document.querySelector('.head-list-info')
      const windowOffsetWidth = window.innerWidth - 39 // 容器宽度;
      if (flLabel) {
        const domoffsetWidth = flLabel.offsetLeft
        // 中间值 =( 容器宽度 - li宽度 ) / 2;
        const diffWidth = (windowOffsetWidth - flLabel.getBoundingClientRect().width) / 2
        console.log(diffWidth, '11111')
        // 目标值 = offset - 中间值
        const targetOffset = -(domoffsetWidth - diffWidth)
        const ulWidth = ul.getBoundingClientRect().width// 开始
        if (-targetOffset < 0) {
          ul.style.transform = 'translateX(0)'
          return
        }
        // 末尾
        if (targetOffset < windowOffsetWidth - ulWidth) {
          ul.style.transform = `translateX(${windowOffsetWidth - ulWidth + 'px'})`
          return
        }
        // 正常
        ul.style.transform = `translateX(${targetOffset + 'px'})`
      }
    },
    // 监听滚动
    onScroll() {
      if (!this.canScroll) {
        this.canScroll = true
        return
      }
      const navContents = document.querySelectorAll('.info-list')
      // console.log(navContents, 1111)
      const offsetTopArr = []
      navContents.forEach((item) => {
        offsetTopArr.push(item.offsetTop - 57)
      })
      // console.log(offsetTopArr, '123')
      const scrollTop = document.querySelector('#ctInfoList').scrollTop
      // console.log(scrollTop, '33333')
      let navIndex = 0
      for (let n = 0; n < offsetTopArr.length; n++) {
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      // console.log(navIndex, 123)
      this.nowItemId = cloneDeep(this.columnInfo[navIndex].templateId)
      // this.$nextTick(() => {
      //   const toLabel = document.getElementById(`nav${this.nowItemId}`)
      //   if (toLabel) {
      //     toLabel.scrollIntoView(true)
      //   }
      // })
      this.adjust()
    },

    // 关闭办事指南
    closeDrawer() {
      document.querySelector('#ctInfoList').removeEventListener('scroll', this.onScroll)
      this.canScroll = true
      this.guideModal = false
      this.showFl = false
      this.nowItemId = 'jbxx'
      this.keyInfo = []
      this.baseInfo = []
      this.columnInfo = []
    },
    // 展开所有分类
    showAllFl() {
      this.showFl = true
    },
    // 关闭
    closeFl() {
      this.showFl = false
    },
  },
  beforeDestroy() {
    setStore({ name: 'chatList', content: this.$data.chatList, type: 'session' })
  }
  // beforeRouteLeave (to, from, next) {
  //   setStore({name: 'chatList', content: this.$data.chatList , type: 'session'})
  //   next()
  // }
}
</script>

<style lang="scss">
.homePage {
  height: calc(100vh - 44px);
  .chat-window {
    background-color: #F0F2F3;
    margin-top: 44px;
    height: calc(100vh - 162px);
    overflow-y: auto;
    .cube-scroll-wrapper {
      padding: 0 12px;
    }
  }
}
.serviceShell-drawer {
  font-size: 0;
  .ivu-drawer-bottom {
    height: calc(100% - 44px) !important;
    .ivu-drawer-content {
      border-radius: 8px 8px 0px 0px;
    }
    .ivu-drawer-header {
      padding: 0 !important;
      border-bottom: 1px solid #E5E5E5;
      .sd-headInfo {
        .headInfo-title {
          display: inline-block;
          vertical-align: top;
          height: 56px;
          line-height: 56px;
          width: 70%;
          padding-left: 12px;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
        .headInfo-icon {
          display: inline-block;
          vertical-align: top;
          width: 30%;
          text-align: right;
          padding-right: 12px;
          height: 56px;
          line-height: 56px;
          .ivu-icon {
            vertical-align: middle;
            font-size: 18px;
            color: #696969;
          }
        }
      }
    }
    .ivu-drawer-body {
      padding: 0;
      height: calc(100% - 57px) !important;
      overflow: unset !important;
      .sd-ct {
        height: 100%;
        padding-bottom: 9px;
        .ct-head {
          border-bottom: 1px solid #E5E5E5;
          display: flex;
          align-items: center;
          padding: 11px 0 6px 0;
          position: relative;
          .head-list {
            height: 39px;
            line-height: 39px;
            width: calc(100% - 39px);
            // overflow-x: scroll;
            display: flex;
            // flex-wrap: nowrap;
            padding: 0 1.5px;
            .head-list-info {
              transition: transform 0.2s;
              transform: translateX(0);
            }
            .list-item {
              display: inline-block;
              vertical-align: top;
              max-width: 105px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              flex-shrink: 0;
              padding: 0 10.5px;
            }
            // .list-bk {
            //   position: absolute;
            //   right: 39px;
            //   top: 11px;
            //   height: 39px;
            //   img {
            //     height: 100%;
            //   }
            // }
            .list-item-c {
              color: #008CFF;
            }
            .head-list-cs-list {
              width: 100%;
              position: relative;
              display: flex;
              height: 100%;
              justify-content: center;
              text-align: center;
              .cube-scroll-wrapper {
                flex: 1;
              }
              .cube-scroll-content {
                display: inline-block;
                vertical-align: top;
              }
              .cube-scroll-nav-bar-items {
                white-space: nowrap
              }
              .cube-scroll-nav-bar-item {
                display: inline-block;
                vertical-align: top;
                padding: 0 10.5px;
                div {
                  font-size: 16px;
                }
              }
              .cube-scroll-nav-bar-item_active {
                div {
                  color: #008CFF !important;
                  font-weight: bold;
                }
              }
            }
          }
          .head-list::-webkit-scrollbar {
            display: none;
          }
          .head-icon {
            width: 39px;
            height: 39px;
            line-height: 39px;
            text-align: center;
            position: relative;
            .ivu-icon {
              font-weight: bold;
              font-size: 18px;
              color: #575757;
            }
            .list-bk {
              position: absolute;
              right: 39px;
              top: 0;
              height: 39px;
              img {
                height: 100%;
              }
            }
          }
        }
        .ct-head-showAll {
          position: absolute;
          width: 100%;
          height: calc(100% - 57px);
          top: 57px;
          .showAll-info {
            position: relative;
            z-index: 2;
            background: #fff;
            .showAll-title {
              height: 50px;
              display: flex;
              align-items: center;
              .title-info {
                width: calc(100% - 46px);
                padding-left: 12px;
                font-size: 14px;
                color: #A6A6A6;
              }
              .title-icon {
                padding: 0 17px;
                width: 46px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                .ivu-icon {
                  font-size: 18px;
                  color: #A2A4A6;
                }
              }
            }
            .showAll-line {
              padding: 0 6px 8px 6px;
              .line-item {
                display: inline-block;
                vertical-align: top;
                margin: 0 6px 12px 6px;
                max-width: 109px;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                color: #1A1A1A;
                padding: 0 8px;
                background-color: #F7F7F7;
                border-radius: 2px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .line-item:hover {
                color: #008CFF;
              }
              .line-item-c {
                color: #008CFF;
              }
            }
          }
          .showAll-back {
            position: absolute;
            z-index: 1;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(55,55,55,.6);
          }
        }
        .ct-info {
          height: calc(100% - 56px);
          overflow-y: auto;
          .info-list {
            .info-item {
              border-bottom: 1px solid #E5E5E5;
              padding: 8px 12px 5px 12px;
              .item-title {
                color: #1A1A1A;
                line-height: 22px;
                font-size: 14px;
                padding-bottom: 8px;
              }
              .item-line {
                padding-bottom: 8px;
                .line-left {
                  display: inline-block;
                  vertical-align: top;
                  width: 78px;
                  padding-right: 2px;
                  font-size: 14px;
                  color: #6D7073;
                  line-height: 22px;
                  word-break : normal;
                  // line-break: anywhere;
                  // word-wrap: break-word;
                  // overflow-wrap: break-word;
                }
                .line-right {
                  display: inline-block;
                  vertical-align: top;
                  width: calc(100% - 78px);
                  font-size: 14px;
                  color: #1A1A1A;
                  line-height: 22px;
                  word-break: break-all;
                  line-break: anywhere;
                  word-wrap: break-word;
                  overflow-wrap: break-word;
                }
              }
              .editor-content-view {
                color: #6D7073;
                border-radius: 5px;
                overflow-x: auto;
                p {
                  font-size: 14px;
                  line-height: 1.5;
                }
              }
              .editor-content-view p,
              .editor-content-view li {
                white-space: pre-wrap; /* 保留空格 */
                word-break: break-all;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
              .editor-content-view blockquote {
                border-left: 8px solid #d0e5f2;
                padding: 10px 10px;
                margin: 10px 0;
                background-color: #f1f1f1;
              }
              .editor-content-view code {
                font-family: monospace;
                background-color: #eee;
                padding: 3px;
                border-radius: 3px;
              }
              .editor-content-view pre > code {
                display: block;
                padding: 10px;
              }
              .editor-content-view table {
                border-collapse: collapse;
              }
              .editor-content-view td,
              .editor-content-view th {
                border: 1px solid #ccc;
                min-width: 50px;
                height: 20px;
              }
              .editor-content-view th {
                background-color: #f1f1f1;
              }
              .editor-content-view ul,
              .editor-content-view ol {
                padding-left: 20px;
              }
              .editor-content-view input[type="checkbox"] {
                margin-right: 5px;
              }
              .generalDetailsTow_centent {
                font-size: 14px;
                video {
                  max-width: 100%;
                }
                img {
                  cursor: pointer;
                  max-width: 100%;
                  height: auto !important;
                }
              }
            }
          }
          .info-list:last-child {
            .info-item:last-child {
              border-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>